module.exports = __webpack_public_path__ + "static/climatisation2-8588b7e241f796a3c488924966d1e260.jpg";